function initDecorHoverEffect(sectionSelector, decorSelector) {
  document.querySelectorAll(sectionSelector).forEach((section) => {
    const decor = section.querySelector(decorSelector);
    if (!decor) return;

    if (window.innerWidth > 1024) {
      let targetX = 0;
      let targetY = 0;
      let currentX = 0;
      let currentY = 0;
      let isHover = false;
      let rafId = null;

      const easeHover = 0.15;
      const easeReturn = 0.05;

      function animate() {
        const ease = isHover ? easeHover : easeReturn;

        currentX += (targetX - currentX) * ease;
        currentY += (targetY - currentY) * ease;

        decor.style.left = `${currentX}px`;
        decor.style.top = `${currentY}px`;
        decor.style.transform = 'translate(-50%, -50%)';

        if (Math.abs(targetX - currentX) > 0.1 || Math.abs(targetY - currentY) > 0.1) {
          rafId = requestAnimationFrame(animate);
        } else {
          rafId = null;
        }
      }

      function updateTargetFromEvent(e) {
        const rect = section.getBoundingClientRect();
        targetX = Math.min(Math.max(e.clientX - rect.left, 10), rect.width - 10);
        targetY = Math.min(Math.max(e.clientY - rect.top, 10), rect.height - 10);
        if (!rafId) animate();
      }

      section.addEventListener('mouseenter', (e) => {
        isHover = true;
        decor.style.transition = 'none';
        updateTargetFromEvent(e);
      });

      section.addEventListener('mousemove', (e) => {
        if (!isHover) return;
        updateTargetFromEvent(e);
      });

      section.addEventListener('mouseleave', () => {
        isHover = false;
        decor.style.transition = 'none';

        const rect = section.getBoundingClientRect();
        targetX = rect.width / 2;
        targetY = rect.height / 2;

        if (!rafId) animate();
      });

      const rect = section.getBoundingClientRect();
      currentX = rect.width / 2;
      currentY = rect.height / 2;
      decor.style.left = `${currentX}px`;
      decor.style.top = `${currentY}px`;
      decor.style.transform = 'translate(-50%, -50%)';
    }
  });
}

initDecorHoverEffect('.what-app-sec', '.what-app-sec__ellipse');
initDecorHoverEffect('.talent-first', '.talent-first__decor');
